export const smoothScroll = (target: string) => {
  document.querySelector(target)?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};
